<template lang="html">
  <div>
    <div
      class="article__comment__item"
      :class="{
        'article__comment__item--reply': this.reply,
        'article__comment__item--waiting': this.comment && !(this.comment.approved),
      }"
    >
      <!-- Loading state -->
      <template v-if="skeleton">
        <img class="skeleton" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" />
        <div class="article__comment__body" style="width: 100%;">
          <p class="article__comment__meta skeleton" style="height: 20px; width: 100%; max-width: 250px;" />
          <p class="article__comment__message skeleton" style="height: 15px; width: 100%; margin-bottom: 15px" />
          <p class="article__comment__message skeleton" style="height: 15px; width: 80%;" />
        </div>
      </template>

      <!-- Comment -->
      <template v-else>
        <img :src="comment.specialist.image_url" v-if="comment.author_type === 'specialist'" />
        <img src="@/assets/images/person-icon.png" v-else />

        <div class="article__comment__body">
          <p class="article__comment__meta">
            {{ new Date(comment.created_at) | moment("D MMMM YYYY") }} | de <span class="article__comment__author">{{ comment.author }}</span>
          </p>
          <p class="article__comment__message">
          <p class="article__comment__message">
            {{ comment.content }}
          </p>

          <small v-if="!(this.comment.approved)" style="color: #3c59a6; display: block; width: 100%;">
            Comentariul tău urmează să fie confirmat de către un admin.
          </small>
        </div>
      </template>
    </div>

    <!-- Reply to comment -->
    <template v-if="!(skeleton)">
      <template v-for="(reply, index) of comment.children">
        <div class="article__divider" v-if="index === 0" />
        <Comment :comment="reply" :parent="comment.id" :reply="true" :key="`reply-${ reply.id }`" />
      </template>

      <div class="article__comment__item--reply article__comment__reply" v-if="!(reply)">
        <div class="article__comment__container" :class="{ 'disabled': commentsWaiting }" v-if="open">
          <input
            :disabled="commentsWaiting"
            placeholder="Scrie un răspuns"
            ref="input"
            v-model="addCommentInput"
          />
          <i
            class="fas fa-paper-plane"
            :class="{ 'disabled': commentsWaiting }"
            @click="
              (addCommentInput.trim() !== '') ? (
                storeComment({
                  content: addCommentInput,
                  parent_id: comment.id,
                }),
                addCommentInput = '',
                open = false
              ) : ''
            "
          ></i>
        </div>
        <button :disabled="commentsWaiting" @click="openReply" v-else>
          Răspunde
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
          <!--
          {{
            comment.children && comment.children.length > 0
              ? `(${ comment.children.length })`
              : ''
          }}
          -->
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Comment                    from './Comment';

export default {
  components: { Comment },
  name: 'Comment',
  props: [ 'comment', 'parent', 'reply', 'skeleton' ],
  data: () => {
    return { open: false, addCommentInput: '' };
  },
  computed: {
    ...mapGetters({
      commentsWaiting: 'article/commentsWaiting',
    }),
  },
  methods: {
    ...mapActions({
      storeComment : 'article/storeComment',
    }),

    openReply() {
      this.open = true;

      setTimeout(() => {
        this.$refs.input.focus();
      }, 200);
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/pages/article';
</style>
